// extracted by mini-css-extract-plugin
export default {"container":"search_container__iWG-J"};